import React, { useState, useEffect, useRef } from 'react';
import UnifiedInputComposer from './UnifiedInputComposer';
import UnifiedMessageList from './UnifiedMessageList';
import UnifiedChatLoadingOverlay from './UnifiedChatLoadingOverlay';
import UnifiedLoadingHeads from './UnifiedLoadingHeads';
import SimpleConversationHeads from './SimpleConversationHeads';
import UnifiedChatHeader from './UnifiedChatHeader';
import { useAuth } from '../AuthProvider';
import { baseUrl_PB, baseUrl_SPB } from '../BaseUrl';
import './AIChatView.scss'; // Component style entry
import ReactMarkdown from 'react-markdown';
import AnimatedDots from './AnimatedDots';
import DeleteBookedItemRoster from '../roster/DeleteBookedItemRoster';
import AddBookedItemListRoster from '../roster/AddBookedItemListRoster';
import { v4 as uuidv4 } from 'uuid';
import FetchEmployeesService from '../roster/FetchEmployeesService';
import Location from '../roster/Location';
import axios from 'axios';
import remarkGfm from 'remark-gfm';

export const ROSTER_CLASSIFICATION_PROMPT = `
You are a strict intent classification engine.

You must classify the user query into exactly ONE of:
- a category string (e.g. categoryx)
- or a JSON object (no extra text, no explanation)

IMPORTANT OUTPUT RULE:
- Return ONLY the result (string OR JSON)
- No comments, no markdown, no extra text

========================================================
HIGHEST PRIORITY RULE (OVERRIDES EVERYTHING)
========================================================
If the user refers to:
- "previous response"
- "previous query"
- "earlier message"
- "above"
- "based on previous"

DO NOT assume this means "previous week".
DO NOT map to CopyPreviousWeek.

If used in a create/update/delete request:
→ continue classification normally
→ DO NOT use category1

========================================================
DATE RULES
========================================================
- this week = Sunday → Saturday (current week)
- last week = Sunday → Saturday (previous week)
- next 7 days = today + next 6 days
- next 14 days = today + next 13 days
- last 7 days = today + previous 6 days
- format = dd-MM-YYYY
- default time:
  starttime = 09:00
  endtime = 17:00

========================================================
CATEGORY PRIORITY (STRICT ORDER)
========================================================

CATEGORY 5 (EXACT MATCH ONLY)
generate roster for everyone
generate roster for all
generate roster for everyone for next week
generate roster for all for next week
→ return: category5

--------------------------------------------------------
CATEGORY 4 (DELETE ROSTER)
--------------------------------------------------------
Delete roster for named people within ±14 days only.

If >14 days → reject.

Return JSON delete format when valid.

--------------------------------------------------------
CATEGORY 1 (CopyPreviousWeek)
--------------------------------------------------------
ONLY if user explicitly says:
"copy roster from previous week to this week"

Return:
{"operation":"CopyPreviousWeek","rostermessage":"<meaningful message>"}

--------------------------------------------------------
CATEGORY 2 (ClearThisWeek)
--------------------------------------------------------
ONLY if user explicitly requests clearing ALL roster for current week.

Return:
{"operation":"ClearThisWeek","rostermessage":"<meaningful message>" }

"category 6: if the user is making a query or asked a question strictly (NOTHING RELATED TO ROSTER) about unavailability (i.e who is unavailable next week), leave (i.e. who is on leave), user work hour preference, company preference this is deemed as category6, simply return one string 'category6' as response"

"category 6-update: if the user is not querying but requesting to save, update, store,delete (i.e. someone is unavailable on...) anything related to unavailability, simply return one string  'category6update' as response"
"category 7-update: if the user is not querying but  requesting to save, update, store,delete (i.e. someone is on leave on...) anything related to leave, this is deemed as category7update, simply return one string  'category7update' as response"
"category 8-update: if the user is not querying but  requesting to save, update, store,delete (i.e. someone wants to work on Monday from 9:00 to 12:00) anything related to work hour preference, this is deemed as category8update, simply return one string  'category8update' as response"
 "category 9-update: if the user is not querying but  requesting to save, update, store,delete (i.e. we are busy on next Sunday) anything related to company work preference, this is deemed as category9update, simply return one string  'category9update' as response"


--------------------------------------------------------
CATEGORY 12 → roster templates
CATEGORY 11 → financial co-pilot - any intent or any info about spending money or anything about invoice, bill, expense, $ figure, we choose category11
CATEGORY 13 -> if user wants to create a Job or Trad , return category13

CATEGORY-INVENTORY-CHECK -> if user mentions inventory and the request contains base64 image data, return category-inventory-check with the image data as an additional field in the JSON response ({category:'category-inventory-check', imageData: '<base64_image_data>'}) for further processing by the inventory system
--------------------------------------------------------
CATEGORY X (FALLBACK)
--------------------------------------------------------
Use ONLY when:
- if the query mention planning or suggestions without listing names then the category will be categoryx
- if the query contains limited details or no mention names, but clearly indicates creating/updating roster then then the category will be categoryx
- planning
- suggestion
- draft
- list users
- vague request

→ return: categoryx
This includes requests such as:
- make a roster for all staff next week
- make a roster for each of my staff from 1 May to 7 May
- build a schedule for the team tomorrow


CATEGORY 3 applies ONLY when ALL are present:
1. Explicit create/update roster intent
2. One or more named staff members
3. Date or date range
4. Time or default time can be inferred
5. No mention of Job, trade Job or task assignment

If ANY of 1-4 missing:
return categoryx

DO NOT generate Category 3 JSON unless named staff members are explicitly listed.

Named staff members are mandatory for Category 3.
Date ranges alone are not sufficient.
“All staff”, “everyone”, “team”, "my staff" are NOT names.
If  a plan is provided with names, date and time then:
Return JSON:
{
  "rostermessage": "meaningful message",
  "operation": "C",
  "items": [
    {
      "name": "name",
      "dates": [
        {
          "date": "dd-MM-YYYY",
          "starttime": "HH:mm",
          "endtime": "HH:mm",
          "operation": "C"
        }
      ]
    }
  ]
}



IMPORTANT:
Even if "previous response" is mentioned, STILL use CATEGORY 3 if intent is create/update.

========================================================
FINAL RULE
========================================================
If unsure between category3 and categoryx:
→ ALWAYS choose categoryx

`;

const unifiedChatStyles = {};

export default function AIChatView() {
  const authContext = useAuth();
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [convoId, setConvoId] = useState(null);
  const [otheruserref, setOtheruserref] = useState('ai-agent@effiez.com.au');
  const [fileList, setFileList] = useState([]);
  const fileInputRef = useRef();
  const [selectedLocation, setSelectedLocation] = React.useState({});
  const [companyAndLocations, setcompanyAndLocations] = useState([]);
  const [bookedItems, setBookedItems] = useState([]);
  const [showModal, setShowModal] = useState(false); // Show by default
    
  const resetFileInput = () => {
    if (fileInputRef.current) fileInputRef.current.value = '';
  };
  const [conversationheads, setConversationheads] = useState([]);
  const [loadingHeads, setLoadingHeads] = useState(false);
  const [loadingChat, setLoadingChat] = useState(false);
  const [loadingAnalytics, setLoadingAnalytics] = useState(false); // Loading anchor for analytics API
  const [searchTerm, setSearchTerm] = useState('');
 
  const [employeeList, setEmployeeList] = useState([]);
  const EMPLOYEE_ROSTER_SYSTEM_PROMPT = [
    'You are a roster assistant for employees in strict read-only mode.',
    'Scope is LIMITED to the current employee\'s own roster information only.',
    'Allowed: check, explain, summarize, and answer questions about the employee\'s own shifts, dates, hours, and roster status.',
    'Not allowed: create, update, edit, delete, assign, swap, approve, publish, or otherwise modify any roster.',
    'Not allowed: provide or infer roster information for other staff, teams, or company-wide planning.',
    'If the user asks for any roster modification or for any non-self roster scope, refuse with: "I can only help you check your own roster. Please contact your manager for roster changes."',
    'Interpret date phrases for lookup only (this week, last week, next 7 days, next 14 days, last 7 days) without asking unnecessary follow-up.',
    'Do not return create/update/delete JSON operations for employee mode.',
    'Keep responses concise and practical.',
  ].join(' ');
  const buildManagerRosterSystemPrompt = (query) => [
    ROSTER_CLASSIFICATION_PROMPT,
  ].join(' ');

  // Call Backend User Roster Analytics on Initial Mount
  useEffect(() => {
    let isMounted = true;
    const now = new Date();
    const payload = {
      locationId: selectedLocation?.id || null,
      companyId: selectedLocation?.companyId || null,
      tday: `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}`
    };
    
    const fetchInitialRosterAnalytics = async () => {
      setLoadingAnalytics(true); // 🌟 Only launch inline loader state
      try {
        const response = await axios.post(`${baseUrl_SPB}/api/v1/openai/userrosteranalytics/chat`, 
          payload,{
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + authContext.token,
          }
        });

        if (isMounted && response.data) {
          const loadedMsg = typeof response.data === 'string' ? response.data : response.data.reply || '';
          loadedMsg !== '' && setMessages([
            { convoId: null, message_content: loadedMsg, user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() }
          ]);
        }
      } catch (error) {
        console.error('Error fetching initial roster analytics:', error);
        if (isMounted) {
          const userRole = (authContext?.role || authContext?.additionalUserInfo?.role || '').toLowerCase();
          const canManageRoster = ["role_manager", "role_cmanager", "role_fmanager", "role_sadmin", "admin", "superadmin"].includes(userRole);
          const starterText = canManageRoster
            ? "Say something i.e. create roster for John [use first name of your resource] from 9am-5pm on 30 April 2025 or create roster for John from 9am-5pm for next 7 days."
            : "You can ask about your own roster only, for example: what are my shifts this week?";
          setMessages([
            { convoId: null, message_content: starterText, user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() }
          ]);
        }
      } finally {
        if (isMounted) {
          setLoadingAnalytics(false); // Turn off inline loader
        }
      }
    };

    fetchInitialRosterAnalytics();
    
    return () => {
      isMounted = false;
    };
  }, [authContext.token]);

  useEffect(() => {
    console.log('selectedLocation changed', selectedLocation);
  }, [authContext.token, selectedLocation]);
  
  useEffect(() => {
    
  }, []);
    async function processRosterQuery(data) {
        const parsedResponse = data.items;
        let newBookedItems = [];
        let itemsToDelete = [];
        if (Array.isArray(parsedResponse)) {
            for (const item of parsedResponse) {
                if (!item.shiftStatus) {
                    const { operation, name, dates, rostermessage, staffId } = item;
                    const resource = employeeList.find(
                        (res) => {
                            const resName = res.firstName.toLowerCase() + " " + res.lastName.toLowerCase();
                            if (name && name.toLowerCase()) {
                                return (resName === name.toLowerCase())
                            }
                            if (staffId) {
                                return (res.id === staffId)
                            }
                        }
                    );
                    if (!resource) {
                        console.log(`Resource not found for name: ${name}`);
                        continue; 
                    }

                    if (data.operation === 'C' || data.operation === 'U') {

                        if (item.date) {

                            newBookedItems.push({
                                id: uuidv4(), 
                                date: item.date ? item.date : '',
                                staffId: resource && resource.id ? resource.id : '', 
                                starttime: item && item.starttime ? item.starttime : '',
                                endtime: item && item.endtime ? item.endtime : '',
                                companyId: authContext.additionalUserInfo.companyId, 
                                locationId: selectedLocation ? selectedLocation.id : '',
                            })

                        }
                        if (dates) {
                            dates.forEach((dateItem) => {
                                newBookedItems.push({
                                    id: uuidv4(),
                                    date: dateItem.date ? dateItem.date : '',
                                    staffId: resource && resource.id ? resource.id : 'XXX',
                                    starttime: dateItem && dateItem.starttime ? dateItem.starttime : '',
                                    endtime: dateItem && dateItem.endtime ? dateItem.endtime : '',
                                    companyId: authContext.additionalUserInfo.companyId,
                                    locationId: selectedLocation ? selectedLocation.id : '',
                                });
                            });
                        }

                    } else if (data.operation === 'D') {
                        itemsToDelete = dates.map((dateItem) => {
                            const matchingItem = bookedItems.find(
                                (booked) =>
                                    booked.date === dateItem.date &&
                                    booked.staffId === resource.id
                            );

                            if (matchingItem) {
                                return {
                                    id: matchingItem.id,
                                    date: dateItem.date,
                                    staffId: resource.id,
                                    companyId: authContext.additionalUserInfo.companyId, 
                                };
                            }
                            return null;
                        }).filter(Boolean); 


                    }
                }
            }
            if (data.operation === 'C' || data.operation === 'U') {

                try {
                    newBookedItems = newBookedItems.filter(newBookedItem => {
                        const matchedBookedItem = bookedItems.find((booked) =>
                            booked.date === newBookedItem.date &&
                            booked.starttime === newBookedItem.starttime &&
                            booked.staffId === newBookedItem.staffId
                        )
                        if (matchedBookedItem) {
                            return false; 
                        }
                        return true;
                    });

                    setBookedItems((prev) => [...prev, ...newBookedItems]); 
                    await AddBookedItemListRoster(newBookedItems, authContext.token);


                } catch (error) {
                    console.error('Error adding booked items:', error);
                }
            } else if (data.operation === 'D') {

                if (itemsToDelete.length > 0) {
                    try {

                        await DeleteBookedItemRoster(itemsToDelete, authContext.token);
                        setBookedItems((prev) =>
                            prev.filter(
                                (booked) =>
                                    !itemsToDelete.some(
                                        (toDelete) => toDelete.id === booked.id
                                    )
                            )
                        );  
                    } catch (error) {
                        console.error('Error deleting booked items:', error);
                    }
                } else {
                    console.log('No matching items found to delete.');
                }
            }
        } else if (parsedResponse.operation === 'ClarifyingQuery') {
            console.log(parsedResponse.rostermessage || 'Please provide more details.');
        } else {
            console.log('Invalid operation or unsupported category.');
        }
    }


  const getInitialLocation = (userInfo) => {
    const locations = userInfo?.company?.locations || userInfo?.locations || [];
    const companyId = userInfo?.company?.id || userInfo?.company?.companyId || '';
    if (Array.isArray(locations) && locations.length > 0) {
      let loc = locations.find(loc => loc.defaultLocation === 'Y') || locations[0];
      if (loc && !loc.companyId) {
        loc = { ...loc, companyId };
      }
      return loc;
    }
    return null;
  };

  
  useEffect(() => {
    loadconversationheads();
  }, [authContext?.additionalUserInfo?.email]);

  
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const data = await FetchEmployeesService(authContext.token, selectedLocation);
        setEmployeeList(data);
      } catch (error) {
        console.error("Failed to fetch employees:", error);
      }
    };

    fetchEmployees();
  }, [authContext.token, selectedLocation]);

  useEffect(() => {
    if (convoId) {
      loadconversation(convoId, otheruserref);
    }
  }, [convoId]);

  function loadconversationheads() {
    const userEmail = authContext?.additionalUserInfo?.email;
    if (!userEmail) return;
    setLoadingHeads(true);
    
    fetch(`${baseUrl_PB}loadconversationheads?user_email=${encodeURIComponent(userEmail)}`)
      .then(res => res.json())
      .then(data => {
        setConversationheads(data);
        setLoadingHeads(false);
      })
      .catch(() => setLoadingHeads(false));
  }

  function loadconversation(convoId, other_user) {
    if (!convoId) return;
    setLoadingChat(true);
    fetch(`${baseUrl_PB}loadconversation?convoId=${convoId}`)
      .then(res => res.json())
      .then(data => {
        setMessages(data);
        setOtheruserref(other_user);
        setLoadingChat(false);
      })
      .catch(() => setLoadingChat(false));
  }

  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim() && fileList.length === 0) return;
    
    const userEmail = authContext?.additionalUserInfo?.email || 'You';
    const userRole = (authContext?.role || authContext?.additionalUserInfo?.role || '').toLowerCase();
    const canManageRoster = ["role_manager", "role_cmanager", "role_fmanager", "role_sadmin", "admin", "superadmin"].includes(userRole);
    const inputMessage = { message_content: input, user_email: userEmail, ctimestamp: new Date().toISOString() };
    
    setMessages(prev => {
      return [...prev, inputMessage, { message_content: 'Thinking', user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() }];
    });
    setInput("");
    const now = new Date();
    const tday = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}`;

    const previousQueries = messages
      .filter(msg => msg.convoId === convoId)
      .slice(-3)
      .map(msg => msg.message_content)
      .join(' ');

    const chatType = 'roster';
    const system_prompt = canManageRoster ? buildManagerRosterSystemPrompt(input) : EMPLOYEE_ROSTER_SYSTEM_PROMPT;
    console.log('selectedLocation', selectedLocation);
    let postData = {
      query: input,
      user_email: userEmail,
      convoId: convoId,
      other_user_email: otheruserref,
      tday,
      chatType,
      selectedLocation,
      system_prompt,
      previousQueries,
    };

    let fetchOptions = {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + authContext.token },
    };

    if (fileList.length > 0) {
      const formData = new FormData();
      formData.append('payload', JSON.stringify(postData));
      Array.from(fileList).forEach((file) => {
        formData.append('image', file);
      });
      fetchOptions.body = formData;
    } else {
      fetchOptions.headers['Content-Type'] = 'application/json';
      fetchOptions.body = JSON.stringify(postData);
    }

    fetch(`${baseUrl_PB}/queryforroster/`, fetchOptions)
      .then(res => res.json())
      .then(data => {
        setMessages(prev => prev.filter(m => m.message_content !== 'Thinking'));

        let extraInventoryMsg = null;
        const inventoryCheckUrl = `${baseUrl_SPB}inventory/aicheck`;
        const containsInventoryCheck = (str) => typeof str === 'string' && str.toLowerCase().includes('inventory/aicheck');

        if (
          containsInventoryCheck(data.rostermessage) ||
          containsInventoryCheck(data.response) ||
          containsInventoryCheck(data.query_message) ||
          containsInventoryCheck(data.question)
        ) {
          extraInventoryMsg = {
            message_content: `I have run the inventory check, please go to <a href="${inventoryCheckUrl}" target="_blank" rel="noopener noreferrer" style="color: #1a73e8; font-weight: 500; text-decoration: underline;">the report link</a> to view the report.`,
            user_email: 'ai-agent@effiez.com.au',
            ctimestamp: new Date().toISOString(),
            isHtml: true,
            isInventoryCheck: true,
            inventoryCheckUrl,
          };
        }

        if (data.convoId) {
          setConvoId(data.convoId);
          loadconversationheads();
          loadconversation(data.convoId, otheruserref);
        }

        let newMessages = [];
        if (data.question) {
          newMessages.push({ message_content: data.question, user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() });
        } else if (data.query_message) {
          newMessages.push({ message_content: data.query_message, user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() });
        } else if (data.rostermessage && !String(data.rostermessage).includes('undefined')) {
           if (data.items) {
                                processRosterQuery(data);
                            }
          newMessages.push({ message_content: data.rostermessage, user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() });
        } else if (data.response) {
          newMessages.push({ message_content: data.response, user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() });
        } else if(data){
          newMessages.push({ message_content:data, user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() });
        } else {
          newMessages.push({ message_content: 'Apologies... unable to process your request at the moment...', user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() });
        }

        if (extraInventoryMsg) {
          newMessages.push(extraInventoryMsg);
        }

        setMessages(prev => ([...prev, ...newMessages]));
        
        setFileList([]);
        resetFileInput();
      })
      .catch(() => {
        setMessages(prev => [...prev, { message_content: 'Error contacting AI.', user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() }]);
      });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFileList(files);
    if (files.length > 0) {
      setInput('inventory check');
    }
  };

  const isChatEmpty = (messages.length === 0);

  return (
    <div className="chat-container" style={{ position: 'relative' }}>

      <Location token={authContext.token} showModal={showModal} setShowModal={setShowModal} companyAndLocations={companyAndLocations} setcompanyAndLocations={setcompanyAndLocations} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} setBookedItems={setBookedItems} bookedItems={bookedItems} />
      
      <div className="sidebar">
        <button
          className="new-chat-btn"
          onClick={() => { 
            setConvoId(null); 
            const userRole = (authContext?.role || authContext?.additionalUserInfo?.role || '').toLowerCase();
            const canManageRoster = ["role_manager", "role_cmanager", "role_fmanager", "role_sadmin", "admin", "superadmin"].includes(userRole);
            const starterText = canManageRoster
              ? "Say something i.e. create roster for John [use first name of your resource] from 9am-5pm on 30 April 2025 or create roster for John from 9am-5pm for next 7 days."
              : "You can ask about your own roster only, for example: what are my shifts this week?";
            setMessages([{ convoId: null, message_content: starterText, user_email: 'ai-agent@effiez.com.au', ctimestamp: new Date().toISOString() }]); 
          }}
        >
          <span>+</span> New chat
        </button>

        <div className="recent-header">
          <span>Recents</span>
        </div>
        
        <div className="search-wrapper">
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder="Search activity..."
          />
        </div>

        <div className="heads-container">
          {loadingHeads ? (
            <UnifiedLoadingHeads styles={unifiedChatStyles} />
          ) : (
            <SimpleConversationHeads
              styles={unifiedChatStyles}
              data={conversationheads.filter(head => {
                if (!searchTerm.trim()) return true;
                const term = searchTerm.trim().toLowerCase();
                return (
                  (head.heading && head.heading.toLowerCase().includes(term)) ||
                  (head.other_user && head.other_user.toLowerCase().includes(term))
                );
              })}
              onSelect={item => setConvoId(item.convoId || item.id)}
              activeId={convoId}
              showAvatars={true}
            />
          )}
        </div>
      </div>

      {/* Main Presentation Canvas */}
      <div className={`chat-content ${isChatEmpty ? 'is-empty' : ''}`}>
        <div className="top-navbar"></div>

        <div className="timeline-stream">
          {/* Only triggers full screen spinner when fetching dynamic conversation logs history */}
          {loadingChat && <UnifiedChatLoadingOverlay styles={unifiedChatStyles} />}
          
          <div className="reading-track">
            <UnifiedMessageList
              styles={unifiedChatStyles}
              data={messages}
              currentUserEmail={authContext?.additionalUserInfo?.email || 'You'}
              renderMessageContent={msg =>
                 (
                  <div className="markdown-content">
                    {msg.message_content==='Thinking' ? <AnimatedDots text="Thinking" /> :
                     <ReactMarkdown remarkPlugins={[remarkGfm]}>{msg.message_content}</ReactMarkdown>}
                  </div>
                )
              }
              selectableText={true}
            />
          </div>
        </div>

        {/* Input Interactive Hub */}
        <div className="action-hub" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          
          {/* 🌟 POSITIONED SAFELY ABOVE THE GREETING PANEL: Shows inline loading animation during initial mount assessment calculation */}
          {loadingAnalytics && (
            <div style={{ margin: '0 auto 16px auto', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40px' }}>
              <AnimatedDots text="Analyzing Roster Data" />
            </div>
          )}
          
            <div className="landing-welcome-hero">
              <h1>How can I help today?</h1>
            </div>
          
         
          <div className="input-max-width">
            {fileList.length > 0 && (
              <div className="upload-pills">
                {fileList.map((file, i) => {
                  const isImage = file.type.startsWith('image/');
                  const isVideo = file.type.startsWith('video/');
                  const url = URL.createObjectURL(file);
                  return (
                    <div key={i} className="file-preview">
                      {isImage && <img src={url} alt={file.name} />}
                      {isVideo && <video src={url} controls={false} />}
                      <span className="file-name">{file.name}</span>
                    </div>
                  );
                })}
              </div>
            )}
                       
            <div className="input-wrapper">
              <UnifiedInputComposer
                styles={unifiedChatStyles}
                value={input}
                onChangeText={setInput}
                onSend={handleSend}
                placeholder="Ask Effiez Assistant..."
                showAttachment={true}
                onAttachmentPress={() => fileInputRef.current && fileInputRef.current.click()}
                attachmentDisabled={false}
                sendDisabled={false}
              />
              <input
                type="file"
                multiple
                accept="image/*,video/*"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                key={fileList.length}
              />
            </div>
            
            <div className="footer-disclaimer">
              Effiez Assistant can make mistakes. Verify important information.
            </div>
          </div>
          
        </div>

      </div>
    </div>
  );
}